import type { App } from 'vue'

let userGroups: string[] = []

const setUserGroups = (groups: string[]) => userGroups = groups

const checkGroup = ({ groups, negate = false }: { groups: string | string[]; negate?: boolean; }): boolean => {
  const normalizedGroups = Array.isArray(groups) ? groups : [groups]
  const match = normalizedGroups.some((g) => userGroups.includes(g))

  return negate ? !match : match
}

const $userInGroup = (groups: string | string[]) => checkGroup({ groups })

const $userNotInGroup = (groups: string | string[]) => checkGroup({ groups, negate: true })

export {
  checkGroup,
  $userInGroup,
  $userNotInGroup,
  setUserGroups,
}

export default {
  install(app: App) {
    app.config.globalProperties.$userInGroup = $userInGroup
    app.config.globalProperties.$userNotInGroup = $userNotInGroup
  },
}
